import React from 'react';
import { BookOpen } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-zinc-100 bg-white mt-16">
      <div className="max-w-6xl mx-auto px-4 py-8 flex flex-col items-center gap-4">
        <a
          href="https://docs.office-arena.lol"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-xs font-medium text-zinc-400 hover:text-zinc-600 transition-colors"
        >
          <BookOpen className="w-3 h-3" />
          <span>Playbook</span>
        </a>
        <div className="text-center text-xs text-zinc-500">
          © {new Date().getFullYear()} Office Arena. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;